<template>
  <transition name="slide-down">
    <div class="app-actionbar" ref="actionbar" v-if="show">
      <div class="container">
        <div class="selection">
          <label class="custom-checkbox checkbox-secondary" @click="$emit('close')">
            <input type="checkbox" class="main-checkbox">
            <span class="label-text"></span>
          </label>

          <span class="text">{{ selectionText }}</span>
        </div>

        <ul class="actions">
          <template v-for="action in actions">
            <li
                :key="`bar-${action.title}`"
                v-show="action.visible"
                :class="actionClass(action)"
                @click.prevent="fire(action)"
                tabindex="0"
            >
              <span :class="`action__icon confirmable-${action.action}`" data-toggle="tooltip" :title="action.title" :data-original-tooltip="action.title" data-placement="bottom">
                <span v-show="action.confirmable && subAction && subAction.title === action.title">
                  <svg style="fill: #ffa500 !important;" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>
                </span>
                <span v-show="!(action.confirmable && subAction && subAction.title === action.title)" v-html="action.icon"></span>
              </span>

              <ul v-if="action.items">
                <li v-for="item in action.items">
                  <a href="#" :class="{'empty': !item.name }" @click.prevent="fire(action, item)">
                    {{ item.name ? item.name : '...' }}
                  </a>
                </li>
              </ul>

              <ul
                  v-if="action.component"
                  class="actions actions__component"
              >
                <li>
                  <component :is="action.component" @fire="fire(action, $event)" :groups="groups"></component>
                </li>
              </ul>
            </li>
          </template>
        </ul>

        <div class="close-actionbar">
          <button class="close" @click="$emit('close')">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#fff"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/></svg>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import TooltipMixin from './plan/mixins/TooltipMixin.js';

export default {
  name: "AppActionBar",

  mixins: [
    TooltipMixin,
  ],

  props: {
    selection: {
      type: Array,
      default: () => {
        return [];
      },
    },

    selectionText: {
      type: String,
      default: '1 item geselecteerd',
    },

    actions: {
      type: Array,
      default: () => {
        return [];
      }
    },

    groups: {
      type: Array,
      default: () => {
        return [];
      }
    },

    closeButton: {
      type: Boolean,
      default: true,
    },

    show: {
      type: Boolean,
      required: true,
    }
  },

  data() {
    return {
      subAction: null,
    }
  },

  mounted() {
    document.addEventListener('click',  (e) => {
      if (!e.target.classList.contains('app-actionbar') && !e.target.closest('.app-actionbar') && !e.target.closest('.swal2-actions')) {
        this.subAction = null;
      }
    });
  },

  watch: {
    show(value) {
      this.reloadTooltips(100);

      if (! value) {
        this.subAction = null;
      }
    }
  },

  methods: {
    actionClass(action) {
      const classes = [];
      if (this.subAction && this.subAction.action === action.action) {
        classes.push('active');
      }

      classes.push(`action__${action.type ? action.type : 'default'}`);

      return classes.join(' ');
    },

    fire(action, subItem) {
      const dataConfirmable = $('[data-confirmable]').eq(0);
      if (dataConfirmable) {
        const originalTitle = dataConfirmable.attr('data-original-tooltip');
        dataConfirmable.attr('data-original-title', originalTitle).removeAttr('data-confirmable');
      }

      if (! subItem && (action.items || action.component || (action.confirmable && (!this.subAction || this.subAction.action !== action.action)))) {
        this.subAction = action;
        setTimeout(() => {
          if (action.confirmable) {
            $('.confirmable-' + action.action + '').attr('data-original-title', 'Bevestigen').attr('data-confirmable', 'true').tooltip('show');
          }

          if (this.$refs.actionbar) {
            const inputElement = this.$refs.actionbar.querySelector('.active input');
            if (inputElement) {
              inputElement.focus();
            }
          }
        }, 100);
      } else {
        this.subAction = null;
        this.$emit('action', { action: action.action, event: action, subAction: subItem });
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/AppActionBar.vue